import { ContentType } from 'types/publishedAssets';

export type ContentSize = NonNullable<ContentType['metadata']['size']>;

// Blocks whose content is worth spanning the page; every other block caps at large. Mirrors the
// tier split the QBB metadata schemas enforce (@zencity/ebuilder-types content/types/*.schema.json).
export const FULL_WIDTH_CONTENT_TYPES = ['image', 'image_gallery', 'video', 'iframe', 'map'] as const;

const CAPPED_SIZES: ContentSize[] = ['small', 'medium', 'large'];
const DEFAULT_SIZE: ContentSize = 'small';
// Narrowest to widest.
export const SIZE_SCALE: ContentSize[] = [...CAPPED_SIZES, 'full'];

/*
 * The width a block should actually render at. A size the block's type does not support —
 * `full` on a capped block, or anything off the scale — falls back to the schema default
 * rather than the nearest cap, so a page never asserts a width the builder cannot express.
 */
export function resolveContentSize(contentType: string | undefined, size: unknown): ContentSize {
  const supported: ContentSize[] = (FULL_WIDTH_CONTENT_TYPES as readonly string[]).includes(contentType ?? '')
    ? SIZE_SCALE
    : CAPPED_SIZES;

  return supported.includes(size as ContentSize) ? (size as ContentSize) : DEFAULT_SIZE;
}

export function isWiderThan(size: ContentSize, than: ContentSize): boolean {
  return SIZE_SCALE.indexOf(size) > SIZE_SCALE.indexOf(than);
}
